import { apiRequest } from "../../apiCall"
import { OutGoingOnSecretarySetRequest } from "../../types/outGoingCallOnSecretary/apiRequestType"

export const getOUtGoingOnSecretarySettings = (id:string) => apiRequest('OutGoingOnSecretary.GetSecretarySettings', {}, `?customerLineId=${id}`,true)      
export const setOUtGoingOnSecretarySettings = (param:OutGoingOnSecretarySetRequest) =>  apiRequest('OutGoingOnSecretary.SetSecretarySettings', param,'',true )

    
   